// import { userService } from '../_services';
import { API_BASE_URL, CELUM_ENDPOINT } from '../config/api';

const user = JSON.parse(localStorage.getItem('user'));
export const headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  // 'Authorization': `celumApiKey 8d6lepmgrcjku9l7i1b8m7po9f`
}
export const endpoint = CELUM_ENDPOINT;
export const devendpoint = API_BASE_URL;

let devheaders = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',  
}
if(user)
  devheaders.Authorization = `Bearer ${user.token}`;
export {devheaders};

export * from './cart.api';
export * from './order.api';
export * from './asset.api';
